import { TZDate } from '@date-fns/tz';
import { addYears, format, parse } from 'date-fns';

/**
 *
 * @param dateString Date sstring in the format of 'yyyy-MM-dd', from the database for DOBs
 * @param timeZone
 * @returns Date object in the specified timezone (default: America/Los_Angeles)
 */
export function stringToDate(
  dateString: string,
  timeZone = 'America/Los_Angeles'
): Date | null {
  const date = new TZDate(
    parse(dateString, 'yyyy-MM-dd', new Date()),
    'UTC'
  ).withTimeZone(timeZone);

  return date || null;
}

export function dateToString(date: Date | null): string {
  if (!date) {
    return '';
  }
  // Convert the date to UTC and format it as 'yyyy-MM-dd'.
  // Important, to avoid timezone issues when saving to the database, which expects UTC dates in this format.
  return format(new TZDate(date, 'UTC'), 'yyyy-MM-dd');
}

export function minimumBirthDate(): Date {
  const MIN_AGE = 13;
  const today = new Date();

  return addYears(today, -MIN_AGE);
}

export const formatDateTime = (date?: Date, formatStr?: string) => {
  return format(date ?? new Date(), formatStr ?? 'MMM dd, yyyy h:mm a');
};

export function getAge(dateString: string) {
  let today = new Date();
  let birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  let m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export function formatCurrentTimeWithTimezone(
  timeZone?: string,
  date: Date = new Date()
): string {
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
    timeZone: timeZone,
  });
}

// Get timezone abbreviation like shortname
export function getTimezoneAbbreviation(timeZone: string): string {
  return (
    new Intl.DateTimeFormat('en-US', {
      timeZoneName: 'short',
      timeZone: timeZone,
    })
      .formatToParts(new Date())
      .find((part) => part.type === 'timeZoneName')?.value || ''
  );
}
